<template>
  <div class="footer border-top text-center">
<!--    <div class="mt-2 mb-2">-->
<!--      <a href="###" class="w-100">-->
<!--        <img src="../../assets/logo.jpg" id="logo" height="50" alt="">-->
<!--        &lt;!&ndash;                <img src="/new2020/images/logo.svg" class="" alt="banner" height="50">&ndash;&gt;-->

<!--      </a>-->
<!--    </div>-->
<!--    <p class="p-0 m-0 mt-1">仍旧遇到问题？请与我们联络</p>-->
<!--    <p class="p-0 m-0">-->
<!--      <small>客服邮件：{{this.common.email}}</small>-->
<!--    </p>-->
<!--    <div style="margin: 0 auto;width: 100%;text-align: center;font-size: 14px;padding-bottom: 10px;">-->
<!--      <a class="power" style="display: inline-block;" @click="$router.push({name:'answer'})" target="_blank">关于我们</a>-->
<!--      &nbsp;&nbsp;-->
<!--      <a class="power" style="display: inline-block;" @click="$router.push({name:'privacy'})" target="_blank">隐私政策</a>-->
<!--    </div>-->
    <vueMarkdown :source="this.common.pagefooter" :breaks="true" :typographer="true" :linkify="true">

    </vueMarkdown>
  </div>
</template>

<script>
import vueMarkdown from "vue-markdown/src/VueMarkdown";
export default {
  name: "footerPage",
  components:{vueMarkdown}
}
</script>

<style scoped>
</style>